<div class="copy-content-ctnr">

    <ng-container *ngIf="displayHelper()">
        <div class="copy-content tf-ng-popover"
             popoverClass="tf-copy-help-popover"
             triggers="mouseenter:mouseleave"
             [ngbPopover]="helperContentPopover"
             (click)="copyToClipboard()"
             id="copyBtn">
            Copy
        </div>
    </ng-container>

    <ng-container *ngIf="!displayHelper()">
        <div class="copy-content"
             (click)="copyToClipboard()"
             id="copyBtn">
            Copy
        </div>
    </ng-container>

    <div class="copy-content-success" [ngClass]="getExtraClasses()" *ngIf="showConfirmation && options.showSuccess">
        <svg width="15px" height="15px" viewBox="0 0 15 15" fill="#7FBA00" class="m-1">
            <path
                d="M8,1 C4.13400675,1 1,4.13400675 1,8 C1,11.8659932 4.13400675,15 8,15 C11.8659932,15 15,11.8659932 15,8 C15,6.14348457 14.2625021,4.36300718 12.9497475,3.05025253 C11.6369928,1.73749788 9.85651543,1 8,1 Z M6.91,12.45 L3.15,8.62 L4.82,7 L6.82,9.11 L11.18,4.75 L12.89,6.47 L6.91,12.45 Z"></path>
        </svg>
        <span>{{ options.successMessage }}</span>
    </div>

    <ng-template #helperContentPopover>
        <span [innerHtml]="options.helperDescription"></span>
    </ng-template>

</div>
